import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
    ImmersiveViewService,
    ImmersiveViewServiceEnum,
} from '@connect-services/client/services/immersive-view/immersive-view.service';
import { ImmersiveViewUiService } from '@connect-services/client/services/immersive-view/immersive-view-ui.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.panel-open]': 'immersiveViewUiService.isPanelOpened()',
    },
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-immersive-view-selection',
    styleUrl: './immersive-view-selection.component.scss',
    templateUrl: './immersive-view-selection.component.html',
})
export class ImmersiveViewSelectionComponent {
    protected readonly ButtonType = ButtonType;
    protected readonly ImmersiveViewServiceEnum = ImmersiveViewServiceEnum;

    // eslint-disable-next-line @typescript-eslint/member-ordering
    protected readonly immersiveViewService = inject(ImmersiveViewService);
    protected readonly immersiveViewUiService = inject(ImmersiveViewUiService);

    protected selectView(view: ImmersiveViewServiceEnum): void {
        this.immersiveViewService.selectImmersiveView(view);
    }
}
